import React, { useState } from 'react';
import { documentTagServices } from '../../../APIServices/documentTagServices';
import { useToast } from '../../../hooks/useToast';

function AddNewDocumentTag({ getDocumentTagData, setModalOpen }) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [documentTag, setDocumentTag] = useState('');

  const addNewDocumentTag = async () => {
    setButtonLoader(true);
    try {
      const data = await documentTagServices.addNewDocumentTag({ documentTag });
      if (data?.statusCode === 200) {
        toast(data?.customMessage || 'Document tag added successfully.', 'ok');
        setDocumentTag('');
        getDocumentTagData();
        setModalOpen('');
      } else {
        toast(data?.customMessage || 'Unable to add document tag.', 'warn');
      }
    } catch (error) {
      toast('Unable to add document tag. Please try again.', 'warn');
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={() => setModalOpen('')}>
      <div className="modal" style={{ maxWidth: 480 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <div className="modal-title">Add Document Tag</div>
            <div className="xs muted">Create a new document tag for workspace metadata</div>
          </div>
          <button className="icon-btn" onClick={() => setModalOpen('')}>
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <div className="field">
            <label className="field-label">
              Document Tag Name
              <span className="req">*</span>
            </label>
            <input
              className="inp"
              autoFocus
              disabled={buttonLoader}
              placeholder="e.g., Critical, Final, Reviewed"
              value={documentTag}
              onChange={(e) => setDocumentTag(e.target.value)}
            />
          </div>
        </div>

        <div className="modal-foot">
          <button className="btn btn-ghost" onClick={() => setModalOpen('')}>Cancel</button>
          <button
            className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
            onClick={addNewDocumentTag}
            disabled={buttonLoader || !documentTag}
          >
            {buttonLoader ? (
              <>
                <div className="buttonLoader"></div>
                <span>Adding...</span>
              </>
            ) : (
              <>
                <i className="ti ti-check"></i>
                <span>Add Document Tag</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddNewDocumentTag;
